import { supabase } from '@/lib/supabase';
import type { OperationsProduct } from '@/services/operationsMetrics';

const PAGE_SIZE = 500;

export async function fetchOperationsProducts(): Promise<OperationsProduct[]> {
  const rows: OperationsProduct[] = [];

  for (let from = 0; ; from += PAGE_SIZE) {
    const { data, error } = await supabase
      .from('db')
      .select('*')
      .order('order', { ascending: true, nullsFirst: false })
      .range(from, from + PAGE_SIZE - 1);

    if (error) throw error;
    const page = (data ?? []) as unknown as OperationsProduct[];
    rows.push(...page);
    if (page.length < PAGE_SIZE) break;
  }

  return rows;
}
